module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"enterTheAnswer":"Введите ответ","requiredField":"Обязательное поле для заполнения"}}')
  delete Component.options._Ctor
}
